export default { sha: '6737642078918f50be6ef98e6e9486ef527396c4', buildNumber: 'undefined' }
